import { store } from "../store/store";
import router from "../router/index";
import { ERROR_MESSSAGE } from "../store/config";

/**
 * Add message to the list of messages
 * @param {Object} param0
 */
function addMessage({ curMessage, primaryUser, secondaryUser }) {
  // Step 1: Get all the messages
  let messages = store.getters["chat/getMessages"];
  if (curMessage.isGroup) {
    messages = store.getters["chat/getGroupMessages"];
  }

  // Step 2: Get all the loaded messages
  let loadedMessagesOfUsers = store.getters["chat/getLoadedMessagesOfUsers"];
  if (curMessage.isGroup) {
    loadedMessagesOfUsers = store.getters["chat/getLoadedMessagesOfGroups"];
  }

  // Step 3: Check if the user's messages has already been loaded and add the message only if messages have been loaded.
  if (primaryUser in loadedMessagesOfUsers) {
    if (loadedMessagesOfUsers[primaryUser].indexOf(secondaryUser) !== -1) {
      // Step 4: Check if there are any messages of the user
      if (secondaryUser in messages) {
        // Step 5: Add message if not already added
        const index = messages[secondaryUser].findIndex(currMessage => {
          return currMessage.id === curMessage.id;
        });
        if (index === -1) {
          store.commit("chat/addMessageFromServer", {
            message: curMessage,
            id: secondaryUser,
            isGroup: curMessage.isGroup
          });
        }
      } else {
        // Step 5: Add message if not already added
        store.commit("chat/addMessageFromServer", {
          message: curMessage,
          id: secondaryUser,
          isGroup: curMessage.isGroup
        });
      }
    }
  }
  // Update friend details
  store.commit("chat/updateFriendDetails", {
    message: curMessage,
    id: secondaryUser,
    isGroup: curMessage.isGroup,
    groupUsername: curMessage.specificName
  });
}

/**
 * Function to show notification
 */
function showNotification(curMessage) {
  store.dispatch("globalMessagePopup", {
    message: ERROR_MESSSAGE.newMessage,
    action: curMessage.isGroup
      ? `/messenger/group/${curMessage.receiver_id}`
      : `/messenger/${curMessage.sent_by}`,
    time: 20
  });
}

export const message = socket => {
  socket.on("messageReceived", curMessage => {
    addMessage({
      curMessage: curMessage,
      primaryUser: curMessage.isGroup
        ? store.getters.getUserDetails.id
        : curMessage.receiver_id,
      secondaryUser: curMessage.isGroup
        ? curMessage.receiver_id
        : curMessage.sent_by
    });

    // Show notification if required
    if (
      !router.currentRoute.fullPath.match(/messenger/g) ||
      (store.getters["chat/getSelectedUserId"] !== curMessage.sent_by &&
        store.getters["chat/getSelectedUserId"] !== curMessage.receiver_id)
    ) {
      showNotification(curMessage);
    }
  });

  socket.on("parentMessageReceived", ({ messages, onlineFriends }) => {
    // Adding the messages
    for (let key in messages) {
      let sendingMessage = store.getters["chat/getSendingMessage"];
      if (messages[key].isGroup) {
        sendingMessage = store.getters["chat/getSendingGroupMessage"];
      }

      if (messages.hasOwnProperty(key)) {
        if (
          messages[key].receiver_id in sendingMessage &&
          sendingMessage[messages[key].receiver_id] > 0
        ) {
          window.addEventListener("done", () => {
            // Add the message
            addMessage({
              curMessage: messages[key],
              primaryUser: messages[key].sent_by,
              secondaryUser: messages[key].receiver_id
            });

            // Set friends who are online as online
            onlineFriends.forEach(friend => {
              store.commit("chat/friendOnline", parseInt(friend));
            });
          });
        } else {
          // Add the message
          addMessage({
            curMessage: messages[key],
            primaryUser: messages[key].sent_by,
            secondaryUser: messages[key].receiver_id
          });

          // Set friends who are online as online
          onlineFriends.forEach(friend => {
            store.commit("chat/friendOnline", parseInt(friend));
          });
        }
      }
    }
  });
};
